"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoTag = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
require("./styles.less");
exports.VideoTag = function (props) {
    return (react_1.default.createElement("div", { className: 'c-video-tag', style: { backgroundColor: props.backgroundColor, color: props.textColor } }, props.title));
};
